"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toaster = exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _pubsubJs = _interopRequireDefault(require("pubsub-js"));

var _reactPose = require("react-pose");

var _oxygenToast = require("@8x8/oxygen-toast");

var _oxygenConfig = require("@8x8/oxygen-config");

var _ToasterWrapper = _interopRequireDefault(require("../styled/ToasterWrapper"));

var events = _interopRequireWildcard(require("../constants/events"));

var _config = require("../config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Toaster = /*#__PURE__*/function (_Component) {
  _inherits(Toaster, _Component);

  var _super = _createSuper(Toaster);

  function Toaster() {
    var _this;

    _classCallCheck(this, Toaster);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      toasts: []
    };
    _this.addSubscriptionToken = undefined;
    _this.removeSubscriptionToken = undefined;
    _this.removeAllSubscriptionToken = undefined;
    _this.configUpdateSubscriptionToken = undefined;
    _this.stackSize = undefined;
    return _this;
  }

  _createClass(Toaster, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.addSubscriptionToken = _pubsubJs["default"].subscribe(events.ADD_TOAST, this.addToast.bind(this));
      this.removeSubscriptionToken = _pubsubJs["default"].subscribe(events.REMOVE_TOAST, this.removeToast.bind(this));
      this.removeAllSubscriptionToken = _pubsubJs["default"].subscribe(events.REMOVE_ALL, this.removeAllToasts.bind(this));
      this.configUpdateSubscriptionToken = _pubsubJs["default"].subscribe(events.CONFIG_UPDATE, function () {
        _this2.stackSize = (0, _config.getConfig)().stackSize;
      });
      this.stackSize = (0, _config.getConfig)().stackSize;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _pubsubJs["default"].unsubscribe(this.addSubscriptionToken);

      _pubsubJs["default"].unsubscribe(this.removeSubscriptionToken);

      _pubsubJs["default"].unsubscribe(this.removeAllSubscriptionToken);

      _pubsubJs["default"].unsubscribe(this.configUpdateSubscriptionToken);
    }
  }, {
    key: "addToast",
    value: function addToast(event, toast) {
      if (this.state.toasts.length === this.stackSize) {
        this.removeToast(undefined, this.state.toasts[0].id);
      }

      this.setState(function (prevState) {
        return {
          toasts: [].concat(_toConsumableArray(prevState.toasts), [toast])
        };
      });
    }
  }, {
    key: "removeToast",
    value: function removeToast(event, toastId) {
      this.setState(function (prevState) {
        return {
          toasts: prevState.toasts.filter(function (toast) {
            return toast.id !== toastId;
          })
        };
      });
    }
  }, {
    key: "removeAllToasts",
    value: function removeAllToasts() {
      this.setState({
        toasts: []
      });
    }
  }, {
    key: "renderToasts",
    value: function renderToasts() {
      return this.state.toasts.map(function (toast) {
        return /*#__PURE__*/_react["default"].createElement(_oxygenToast.Toast, {
          size: toast.size,
          type: toast.type,
          actions: toast.actions,
          hideCloseControl: toast.hideCloseControl,
          onCloseControlClick: function onCloseControlClick() {
            return toast.close();
          },
          onMouseEnter: function onMouseEnter() {
            return toast.pauseExpirationTimeout();
          },
          onMouseLeave: function onMouseLeave() {
            return toast.resumeExpirationTimeout();
          },
          key: toast.id
        }, toast.content);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _getConfig = (0, _config.getConfig)(),
          size = _getConfig.size,
          targetNode = _getConfig.targetNode;

      var theme = this.props.theme;
      return /*#__PURE__*/_reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
        theme: theme
      }, /*#__PURE__*/_react["default"].createElement(_ToasterWrapper["default"], {
        size: size
      }, /*#__PURE__*/_react["default"].createElement(_oxygenToast.ToastStack, null, /*#__PURE__*/_react["default"].createElement(_reactPose.PoseGroup, null, this.renderToasts())))), targetNode);
    }
  }]);

  return Toaster;
}(_react.Component);

exports.Toaster = Toaster;
Toaster.propTypes = {
  /**
   * Toast theme
   */
  theme: _propTypes["default"].object.isRequired
};

var _default = (0, _oxygenConfig.withTheme)(Toaster, 'toast');

exports["default"] = _default;